import Dialog, { DialogProps } from '@mui/material/Dialog'
import { useState, useEffect } from 'react'

const useIsMobileBreakpoint = () => {
  const [windowSize, setWindowSize] = useState<{
    width: number | undefined
    height: number | undefined
  }>({
    width: undefined,
    height: undefined,
  })
  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      })
    }
    window.addEventListener('resize', handleResize)
    handleResize()
    return () => window.removeEventListener('resize', handleResize) // remove on cleanup
  }, [])
  return !!windowSize.width && windowSize.width < 600 ? true : false
}

type MobileFullScreenDialogProps = Omit<DialogProps, 'fullScreen'>

const MobileFullScreenDialog: React.FC<
  React.PropsWithChildren<MobileFullScreenDialogProps>
> = (props) => {
  const isMobile = useIsMobileBreakpoint()
  return (
    <Dialog fullScreen={isMobile} {...props}>
      {props.children}
    </Dialog>
  )
}

export default MobileFullScreenDialog
